/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_SamplesInputs */

const en_gc_home_samples = /** @type {(inputs: Gc_Home_SamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a workbook preview`)
};

const zh_gc_home_samples = /** @type {(inputs: Gc_Home_SamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择工作簿预览`)
};

/**
* | output |
* | --- |
* | "Choose a workbook preview" |
*
* @param {Gc_Home_SamplesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_samples = /** @type {((inputs?: Gc_Home_SamplesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_SamplesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_samples(inputs)
	return zh_gc_home_samples(inputs)
});
export { gc_home_samples as "gc.home.samples" }